module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/pin_black-9ad46b557d31e29805f108777d4dd077.svg";